import { z } from 'zod';
import { c } from '../../contract';
import {
  AdSkipsBalanceSchema,
  AdSkipsEarnBodySchema,
  AdSkipsEarnResponseSchema,
  AdSkipsSpendBodySchema,
  AdSkipsSpendResponseSchema,
} from '../../types/AdSkips';

export const adSkipsRouter = c.router(
  {
    getBalance: {
      summary: 'Get the current ad-skip balance for the user',
      method: 'GET',
      path: '/balance',
      responses: {
        200: AdSkipsBalanceSchema,
      },
    },
    earn: {
      summary: 'Credit ad skips after a rewarded ad is watched to completion',
      method: 'POST',
      path: '/earn',
      body: AdSkipsEarnBodySchema,
      responses: {
        200: AdSkipsEarnResponseSchema,
      },
    },
    spend: {
      summary: 'Spend one ad skip to bypass a countdown wait',
      method: 'POST',
      path: '/spend',
      body: AdSkipsSpendBodySchema,
      responses: {
        200: AdSkipsSpendResponseSchema,
        409: z.object({ message: z.string(), skips: z.number().int().min(0) }),
      },
    },
  },
  { pathPrefix: '/ad-skips' },
);
